import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectOfflineOrdersHistory: "selectOfflineOrdersHistory [Action]",
  selectOfflineOrdersHistoryLoading:
    "selectOfflineOrdersHistoryLoading [Action]",
  selectOfflineOrdersHistoryAsync: "selectOfflineOrdersHistoryAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_offline_orders_history_Reducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectOfflineOrdersHistory:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectOfflineOrdersHistoryLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectOfflineOrdersHistoryLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "offlineorder",
    method_type: "select_offline_orders_history",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectOfflineOrdersHistory,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectOfflineOrdersHistoryLoading,
      payload: false,
    });
  }
}

export function* selectOfflineOrdersHistory() {
  yield takeLatest(actionTypes.selectOfflineOrdersHistoryAsync, handleWorker);
}
